module.exports = __webpack_public_path__ + "img/bid.0507e7bc.jpg";